/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable react/jsx-sort-props */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import validate from 'validate.js';
import { withRouter } from 'react-router-dom';
import { Grid, Typography } from '@mui/material';
import moment from 'moment';
import * as Roles from '../../../constants/role';
import * as selectorsProgramacaoDiariaDia from '../../../store/programacaoDiariaDia/reducer';
import * as actionsProgramacaoDiariaDia from '../../../store/programacaoDiariaDia/actions';
import * as selectorsAuth from '../../../store/auth/reducer';
import {
  DatePickerV2,
  DialogDefaultV2,
  InputV2,
  UsuarioSelectV2,
} from '../../../components/v2';
import { buildRequiredSchema } from 'utils';
import ItensContainer from './ItensContainer';

const diaSchema = buildRequiredSchema(['referenceDay', 'inspetorId']);

const Formulario = ({
  open,
  id,
  onClose,
  findProgramacaoDiariaDiaById,
  clearProgramacaoDiariaDia,
  saveProgramacaoDiariaDia,
  updateProgramacaoDiariaDia,
  selectedProgramacaoDiariaDia,
  authData,
}) => {
  const [values, setValues] = useState({
    referenceDay: moment().valueOf(),
    inspetorId: authData?.id,
    itens: [],
  });
  const [errors, setErrors] = useState({});
  const [itensError, setItensError] = useState(false);
  const [readOnly, setReadOnly] = useState(false);

  useEffect(() => {
    if (open && id) {
      findProgramacaoDiariaDiaById(id);
    }
  }, [open, id, findProgramacaoDiariaDiaById]);

  useEffect(() => {
    if (!open) return;

    if (id && selectedProgramacaoDiariaDia && id === selectedProgramacaoDiariaDia.id) {
      setValues({
        ...selectedProgramacaoDiariaDia,
        referenceDay: selectedProgramacaoDiariaDia.referenceDay
          ?? selectedProgramacaoDiariaDia.data
          ?? moment().valueOf(),
        itens: selectedProgramacaoDiariaDia.itens || [],
      });
      setReadOnly(!!selectedProgramacaoDiariaDia.readOnly);
      setErrors({});
      setItensError(false);
      return;
    }

    if (!id) {
      setValues({
        referenceDay: moment().valueOf(),
        inspetorId: authData?.id,
        itens: [],
      });
      setReadOnly(false);
      setErrors({});
      setItensError(false);
    }
  }, [open, id, selectedProgramacaoDiariaDia, authData]);

  const onCloseLocal = isSave => {
    setErrors({});
    setItensError(false);
    setValues({
      referenceDay: moment().valueOf(),
      inspetorId: authData?.id,
      itens: [],
    });
    clearProgramacaoDiariaDia();
    onClose(isSave);
  };

  const saveCallback = success => {
    if (success) onCloseLocal(true);
  };

  const onSave = () => {
    const erros = validate(values, diaSchema);
    const semItens = !values.itens || values.itens.length === 0;
    setErrors(erros || {});
    setItensError(semItens);

    if (erros || semItens) return;

    const payload = {
      ...values,
      itens: values.itens,
    };

    if (values.id) {
      updateProgramacaoDiariaDia(payload, saveCallback);
    } else {
      saveProgramacaoDiariaDia(payload, saveCallback);
    }
  };

  return (
    <DialogDefaultV2
      open={open}
      handlerCancel={() => onCloseLocal(false)}
      handlerConfirm={onSave}
      title={id ? 'Programação do Dia' : 'Nova Programação do Dia'}
      confirmMessage="Salvar"
      maxWidth="md"
      fullWidth
      readOnly={readOnly}
    >
      <Grid container spacing={1} sx={{ mt: 0 }}>
        <Grid size={{ xs: 12, sm: 6 }}>
          <DatePickerV2
            label="Data"
            isRequired
            onChange={referenceDay => setValues({ ...values, referenceDay })}
            value={values.referenceDay}
            disabled={readOnly}
            error={!!(errors && errors.referenceDay)}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6 }}>
          <InputV2
            label="Data Inclusão"
            disabled
            value={values.createdAt || ''}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6 }}>
          <UsuarioSelectV2
            label="Inspetor"
            isRequired
            onSelect={inspetorId => setValues({ ...values, inspetorId })}
            ativo
            grupos={[Roles.ADMIN, Roles.INSPETOR]}
            value={values.inspetorId}
            disabled={readOnly}
            error={!!(errors && errors.inspetorId)}
          />
        </Grid>
        {values.status && (
          <Grid size={{ xs: 12, sm: 6 }}>
            <InputV2 label="Status" disabled value={values.status} />
          </Grid>
        )}

        <ItensContainer
          itens={values.itens}
          onChange={itens => {
            setValues({ ...values, itens });
            if (itens.length) setItensError(false);
          }}
          disabled={readOnly}
          showError={itensError}
        />

        {itensError && (
          <Grid size={{ xs: 12 }}>
            <Typography variant="caption" color="error">
              Adicione ao menos um item à programação do dia.
            </Typography>
          </Grid>
        )}
      </Grid>
    </DialogDefaultV2>
  );
};

Formulario.propTypes = {
  open: PropTypes.bool.isRequired,
  id: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  findProgramacaoDiariaDiaById: PropTypes.func.isRequired,
  clearProgramacaoDiariaDia: PropTypes.func.isRequired,
  saveProgramacaoDiariaDia: PropTypes.func.isRequired,
  updateProgramacaoDiariaDia: PropTypes.func.isRequired,
  selectedProgramacaoDiariaDia: PropTypes.object,
  authData: PropTypes.object.isRequired,
};

Formulario.defaultProps = {
  id: null,
  selectedProgramacaoDiariaDia: null,
};

const mapStateToProps = state => ({
  selectedProgramacaoDiariaDia: selectorsProgramacaoDiariaDia.getSelectedProgramacaoDiariaDia(state),
  authData: selectorsAuth.getAuth(state),
});

const mapDispatchToProps = dispatch => bindActionCreators({
  ...actionsProgramacaoDiariaDia,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Formulario));
